/* ============================================================
   FRONT.JS — AMK CASINOS (Rebuild 2026)
   Data-driven Cards (2 Marken: Freshbet + Roy Partners) · Sortierkopf ·
   20X-Boost (Supabase) · Twitch-Live (Supabase) · FX
   ============================================================ */
(function () {
  'use strict';

  var CDN = 'https://cdn.shopify.com/s/files/1/0965/9813/1028/files/';

  /* --- CASINO-HUB ---------------------------------------------------------
     Die Casinos kommen aus der Zentrale (Kanal "front"). Die Liste unten
     bleibt als Sicherheitsnetz stehen: Ist der Hub nicht erreichbar oder
     noch leer, zeigt die Seite exakt das, was sie heute zeigt.
     Abschalten: window.NK_HUB_OFF = true (z.B. im Theme-Editor).
  ------------------------------------------------------------------------ */
  var HUB_URL = (window.NK_HUB_URL ||
    'https://cbwxgikndyyzdslmfpmo.supabase.co/functions/v1/vertrieb') + '/casinos/front';

  /* --- DIE 7 GIVEAWAY-CASINOS (einzige Datenquelle) --- */
  var CASINOS = [
    {
      id: 'izzi', rank: 1, featured: true, brand: 'roy', name: 'IZZI',
      logo: CDN + 'IZZ.svg?v=1785998042', logoMod: '',
      bonus: '300% Bonuspaket bis 1.500€ + 500 Freispiele',
      bonusPct: 300, maxBonus: 1500, freespins: 500,
      payoutText: 'Schnelle Auszahlung', payoutRank: 3,
      code: 'NOURIAMK',
      highlight: '🎁 <strong>100 Freispiele OHNE Einzahlung</strong> mit Code <strong>NOURIAMK</strong> — zusätzlich zum Bonuspaket über 4 Einzahlungen.',
      pkg: {
        sum: '300% bis 1.500€ + bis zu 500 Freispiele',
        steps: [
          { n: 1, main: '100% bis 600€', extra: '+ bis zu 500 Freispiele (50 FS ab 20€)', min: 'ab 20€' },
          { n: 2, main: '75% bis 300€', extra: '', min: 'ab 20€' },
          { n: 3, main: '75% bis 300€', extra: '', min: 'ab 20€' },
          { n: 4, main: '50% bis 300€', extra: '', min: 'ab 20€' }
        ],
        wagerBonus: 40, wagerFs: 30, maxWin: 10,
        alt: '750 USD | 1.500 CAD'
      },
      cta: 'https://izziway65.com/ca4c47573'
    },
    {
      id: 'iris', rank: 2, brand: 'roy', name: 'IRIS',
      logo: 'https://iriscasino.net/wp-content/uploads/2026/05/logo-new-scaled.png', logoMod: '',
      bonus: '350% Bonuspaket bis 1.300€',
      bonusPct: 350, maxBonus: 1300, freespins: 0,
      payoutText: 'Schnelle Auszahlung', payoutRank: 3,
      code: 'NOURIAMK',
      highlight: '🎁 <strong>100 Freispiele OHNE Einzahlung</strong> mit Code <strong>NOURIAMK</strong> — zusätzlich zum Bonuspaket über 3 Einzahlungen.',
      pkg: {
        sum: '350% bis 1.300€',
        steps: [
          { n: 1, main: '125% bis 600€', extra: '', min: 'ab 10€' },
          { n: 2, main: '100% bis 400€', extra: '', min: 'ab 10€' },
          { n: 3, main: '125% bis 300€', extra: '', min: 'ab 10€' }
        ],
        wagerBonus: 40, wagerFs: 0, maxWin: 10,
        alt: '1.300 USD'
      },
      cta: 'https://irisroute64.com/c2a2a120d'
    },
    {
      id: 'fugu', rank: 3, brand: 'roy', name: 'FUGU',
      logo: CDN + 'Fugo.webp?v=1785998273', logoMod: '',
      bonus: '250% Bonuspaket bis 900€ + 500 Freispiele',
      bonusPct: 250, maxBonus: 900, freespins: 500,
      payoutText: 'Schnelle Auszahlung', payoutRank: 3,
      code: 'NOURIAMK',
      highlight: '🎁 <strong>100 Freispiele OHNE Einzahlung</strong> mit Code <strong>NOURIAMK</strong> — zusätzlich zum Bonuspaket über 3 Einzahlungen.',
      pkg: {
        sum: '250% bis 900€ + bis zu 500 Freispiele',
        steps: [
          { n: 1, main: '125% bis 600€', extra: '', min: 'ab 20€' },
          { n: 2, main: 'bis zu 500 Freispiele', extra: '(25 FS ab 20€)', min: 'ab 20€' },
          { n: 3, main: '125% bis 300€', extra: '', min: 'ab 20€' }
        ],
        wagerBonus: 40, wagerFs: 35, maxWin: 10,
        alt: '450 USD | 900 CAD'
      },
      cta: 'https://fuguway610.com/c663cfe7b'
    },
    {
      id: 'irwin', rank: 4, brand: 'roy', name: 'IRWIN',
      logo: CDN + 'Irwin_PNG.png?v=1786000481', logoMod: 'nk-card__logo--sq',
      bonus: '225% Bonuspaket bis 900€ + 400 Freispiele',
      bonusPct: 225, maxBonus: 900, freespins: 400,
      payoutText: 'Schnelle Auszahlung', payoutRank: 3,
      code: 'NOURIAMK',
      highlight: '🎁 <strong>100 Freispiele OHNE Einzahlung</strong> mit Code <strong>NOURIAMK</strong> — zusätzlich zum Bonuspaket über 3 Einzahlungen.',
      pkg: {
        sum: '225% bis 900€ + bis zu 400 Freispiele',
        steps: [
          { n: 1, main: '150% bis 600€', extra: '', min: 'ab 20€' },
          { n: 2, main: 'bis zu 400 Freispiele', extra: '(25 FS ab 20€)', min: 'ab 20€' },
          { n: 3, main: '75% bis 300€', extra: '', min: 'ab 20€' }
        ],
        wagerBonus: 40, wagerFs: 35, maxWin: 10,
        alt: '450 USD | 900 CAD'
      },
      cta: 'https://irwinway65.com/c7a7eefe2'
    },
    {
      id: 'martin', rank: 5, brand: 'roy', name: 'MARTIN',
      logo: CDN + 'Martin.svg?v=1785998061', logoMod: '',
      bonus: '225% Bonuspaket bis 900€ + 500 Freispiele',
      bonusPct: 225, maxBonus: 900, freespins: 500,
      payoutText: 'Schnelle Auszahlung', payoutRank: 3,
      code: 'NOURIAMK',
      highlight: '🎁 <strong>100 Freispiele OHNE Einzahlung</strong> mit Code <strong>NOURIAMK</strong> — zusätzlich zum Bonuspaket über 3 Einzahlungen.',
      pkg: {
        sum: '225% bis 900€ + bis zu 500 Freispiele',
        steps: [
          { n: 1, main: '150% bis 600€', extra: '', min: 'ab 20€' },
          { n: 2, main: 'bis zu 500 Freispiele', extra: '(30 FS ab 20€)', min: 'ab 20€' },
          { n: 3, main: '75% bis 300€', extra: '', min: 'ab 20€' }
        ],
        wagerBonus: 40, wagerFs: 35, maxWin: 10,
        alt: '450 USD | 900 CAD'
      },
      cta: 'https://martinway66.com/c47665c12'
    },
    {
      id: 'flagman', rank: 6, brand: 'roy', name: 'FLAGMAN',
      logo: CDN + 'Flagman_png.png?v=1786000468', logoMod: 'nk-card__logo--sqw',
      bonus: '225% Bonuspaket bis 900€ + 500 Freispiele',
      bonusPct: 225, maxBonus: 900, freespins: 500,
      payoutText: 'Schnelle Auszahlung', payoutRank: 3,
      code: 'NOURIAMK',
      highlight: '🎁 <strong>100 Freispiele OHNE Einzahlung</strong> mit Code <strong>NOURIAMK</strong> — zusätzlich zum Bonuspaket über 3 Einzahlungen.',
      pkg: {
        sum: '225% bis 900€ + bis zu 500 Freispiele',
        steps: [
          { n: 1, main: '150% bis 600€', extra: '', min: 'ab 20€' },
          { n: 2, main: 'bis zu 500 Freispiele', extra: '(30 FS ab 20€)', min: 'ab 20€' },
          { n: 3, main: '75% bis 300€', extra: '', min: 'ab 20€' }
        ],
        wagerBonus: 40, wagerFs: 35, maxWin: 10,
        alt: '450 USD | 900 CAD'
      },
      cta: 'https://flagmanway68.com/cd5cb0bca'
    },
    {
      id: 'freshbet', rank: 7, brand: 'freshbet', name: 'Freshbet',
      logo: CDN + 'Freshbet.png?v=1781871149', logoMod: '',
      bonus: '200% Bonus + 10€ Freebet',
      bonusPct: 200, maxBonus: 1000, freespins: 0,
      payoutText: '1 Std. Crypto · 2–3 Std. Bank', payoutRank: 1,
      code: 'Nouri', autoNoDep: true,
      highlight: '🎁 <strong>100 Freispiele OHNE Einzahlung</strong> auf <strong>Book of Witches</strong> — mit Code <strong>Nouri</strong> aktivieren.',
      pkg: null,
      cta: 'https://go.freshaffs.com/visit/?bta=49070&nci=6119'
    }
  
  ];

  /* — Gemeinsame Blöcke — */
  var PAY_METHODS = [
    ['fa-brands fa-cc-visa', 'Visa'], ['fa-brands fa-cc-mastercard', 'Mastercard'],
    ['fa-brands fa-paypal', 'PayPal'], ['fa-solid fa-bolt', 'Sofort'],
    ['fa-solid fa-building-columns', 'SEPA'], ['fa-solid fa-wallet', 'MiFinity'],
    ['fa-solid fa-wallet', 'Jeton'], ['fa-solid fa-mobile-screen-button', 'Revolut'],
    ['fa-solid fa-ticket', 'Flexepin'], ['fa-solid fa-money-bill-transfer', 'Interac'],
    ['fa-brands fa-bitcoin', 'Bitcoin'], ['fa-brands fa-ethereum', 'Ethereum'],
    ['fa-solid fa-coins', 'Litecoin'], ['fa-solid fa-coins', 'Tether (USDT)']
  ];
  // Echte Anbieter je Marke (auf den Casino-Seiten geprüft, kuratiert auf die Top-Namen)
  var PROVIDERS_ROY = ['Pragmatic Play', 'Play’n GO', 'NetEnt', 'Nolimit City', 'Hacksaw Gaming', 'Yggdrasil', 'ELK Studios', 'BGaming', 'Novomatic', 'Evolution'];
  var PROVIDERS_FRESH = ['Pragmatic Play', 'Hacksaw Gaming', 'Nolimit City', 'NetEnt', 'Red Tiger', 'Thunderkick', 'Wazdan', 'Novomatic', 'Betsoft', 'BGaming', 'Playson', 'EGT'];

  /* Zahlen fuer die Anzeige. Ganze Zahlen wie bisher mit Tausenderpunkt,
     Kommazahlen bleiben erhalten — sonst wuerde aus 0,05 BTC eine 0. */
  function nfmt(n) {
    var v = Number(n) || 0;
    return Number.isInteger(v)
      ? v.toLocaleString('de-DE')
      : v.toLocaleString('de-DE', { maximumFractionDigits: 8 });
  }
  /* Einheit anhaengen: Symbole kleben am Betrag (1.500€), Kuerzel bekommen
     einen Abstand (1 BTC). */
  function einheitSuffix(u) {
    var e = String(u || '€').trim() || '€';
    return e.length > 1 ? ' ' + e : e;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }

  /* --- KARTEN-MARKUP --- */
  function statFace(front, value, suffix, label, explain, group) {
    return '<div class="nk-card__stat" role="button" tabindex="0" aria-label="' + esc(label) + ' erklären"><div class="nk-card__stat-inner">' +
      '<div class="nk-card__stat-face nk-card__stat-front"><i class="fa-solid fa-circle-info nk-card__stat-hint"></i>' +
      '<span class="nk-card__stat-value" data-count="' + value + '" data-suffix="' + suffix + '"' + (group ? ' data-group' : '') + '>' +
      (group ? nfmt(value) : value) + suffix + '</span><span class="nk-card__stat-label">' + esc(label) + '</span></div>' +
      '<div class="nk-card__stat-face nk-card__stat-back"><span class="nk-card__stat-explain">' + esc(explain) + '</span>' +
      '<i class="fa-solid fa-rotate-left nk-card__stat-hint nk-card__stat-hint--back"></i></div></div></div>';
  }

  // Symbol zu einem Zahlungsnamen finden (fuer Listen aus dem Casino-Hub)
  var PAY_ICONS = {};
  PAY_METHODS.forEach(function (p) { PAY_ICONS[p[1].toLowerCase()] = p[0]; });
  function payIcon(name) {
    return PAY_ICONS[String(name).toLowerCase()] || 'fa-solid fa-credit-card';
  }

  function payPanel(c) {
    // Rueckwaertskompatibel: frueher wurde nur die Marke uebergeben
    var brand = (c && typeof c === 'object') ? c.brand : c;
    var ownPays = (c && typeof c === 'object' && c.pay && c.pay.length) ? c.pay : null;
    var ownProvs = (c && typeof c === 'object' && c.providers && c.providers.length) ? c.providers : null;

    var pays = ownPays
      ? ownPays.map(function (name) {
          return '<span class="nk-pay"><i class="' + payIcon(name) + '"></i>' + esc(name) + '</span>';
        }).join('')
      : PAY_METHODS.map(function (p) {
          return '<span class="nk-pay"><i class="' + p[0] + '"></i>' + esc(p[1]) + '</span>';
        }).join('');

    var list = ownProvs || (brand === 'freshbet' ? PROVIDERS_FRESH : PROVIDERS_ROY);
    var provs = list.map(function (name) {
      return '<span class="nk-prov"><i class="fa-solid fa-puzzle-piece"></i>' + esc(name) + '</span>';
    }).join('');
    return '<div class="nk-card__pay">' +
      '<button class="nk-card__pay-toggle" type="button" aria-expanded="false"><i class="fa-solid fa-credit-card"></i> Details &amp; Zahlungen <i class="fa-solid fa-chevron-down nk-card__pay-caret"></i></button>' +
      '<div class="nk-card__pay-panel"><div class="nk-card__pay-inner">' +
        '<div class="nk-card__providers"><div class="nk-card__providers-title"><i class="fa-solid fa-dice"></i> Spieleanbieter</div><div class="nk-card__providers-grid">' + provs + '</div></div>' +
        '<div class="nk-card__providers"><div class="nk-card__providers-title"><i class="fa-solid fa-credit-card"></i> Zahlungsmethoden</div><div class="nk-card__pay-grid">' + pays + '</div></div>' +
      '</div></div></div>';
  }

  /* --- BONUSPAKET-BLOCK (einklappbar, mehrere Einzahlungen) --- */
  function pkgHTML(c) {
    var p = c.pkg;
    if (!p || !p.steps || !p.steps.length) {
      return '<div class="nk-pkg nk-pkg--single">' +
        '<div class="nk-pkg__head">' +
          '<span class="nk-pkg__badge"><i class="fa-solid fa-gift"></i> Willkommensbonus</span>' +
          '<span class="nk-pkg__sum">' + esc(c.bonus) + ' · nur 1. Einzahlung</span>' +
        '</div>' +
        '<div class="nk-pkg__foot">' +
          '<span class="nk-pkg__meta"><i class="fa-solid fa-rotate"></i> Bonus 40× umsetzen</span>' +
          '<span class="nk-pkg__meta"><i class="fa-solid fa-coins"></i> Max. Einsatz 5€</span>' +
        '</div></div>';
    }
    var steps = p.steps.map(function (s) {
      return '<li class="nk-pkg__step">' +
        '<span class="nk-pkg__step-n">' + s.n + '.</span>' +
        '<span class="nk-pkg__step-body">' +
          '<span class="nk-pkg__step-main">' + esc(s.main) + '</span>' +
          (s.extra ? '<span class="nk-pkg__step-extra">' + esc(s.extra) + '</span>' : '') +
        '</span>' +
        '<span class="nk-pkg__step-min">' + esc(s.min) + '</span>' +
      '</li>';
    }).join('');

    var metas = '<span class="nk-pkg__meta"><i class="fa-solid fa-rotate"></i> Bonus ' + p.wagerBonus + '× umsetzen</span>';
    if (p.wagerFs) metas += '<span class="nk-pkg__meta"><i class="fa-solid fa-dice-five"></i> Freispiele ' + p.wagerFs + '× umsetzen</span>';
    if (p.maxWin) metas += '<span class="nk-pkg__meta"><i class="fa-solid fa-trophy"></i> Max. Gewinn ' + p.maxWin + '× Bonus</span>';

    return '<div class="nk-pkg">' +
      '<button class="nk-pkg__toggle" type="button" aria-expanded="false">' +
        '<span class="nk-pkg__head">' +
          '<span class="nk-pkg__badge"><i class="fa-solid fa-layer-group"></i> Bonuspaket</span>' +
          '<span class="nk-pkg__sum">' + esc(p.sum) + '</span>' +
          '<span class="nk-pkg__count">verteilt auf ' + p.steps.length + ' Einzahlungen</span>' +
        '</span>' +
        '<span class="nk-pkg__more">Einzahlungen ansehen <i class="fa-solid fa-chevron-down nk-pkg__caret"></i></span>' +
      '</button>' +
      '<div class="nk-pkg__panel"><div class="nk-pkg__inner">' +
        '<ol class="nk-pkg__steps">' + steps + '</ol>' +
        '<div class="nk-pkg__foot">' + metas + '</div>' +
        (p.alt ? '<div class="nk-pkg__alt">Auch in anderen Währungen: ' + esc(p.alt) + '</div>' : '') +
      '</div></div>' +
    '</div>';
  }

  /* Bonusart. Der Hub liefert die genaue Art in bonusType:
       'nonsticky'  erst das eigene Geld, Auszahlen jederzeit moeglich
       'sticky'     Einzahlung und Bonus verschmelzen
       'rmw'        Real Money Wager: sticky, aber Umsatz auf das Echtgeld
       null         in der Zentrale noch nicht geprueft -> kein Abzeichen
     Aeltere Antworten kennen nur sticky true/false; daraus wird die grobe Art
     abgeleitet. undefined heisst: die Karte kommt aus der eingebauten Liste
     unten im Skript, und die ist durchweg nonsticky. */
  var BONUSARTEN = {
    nonsticky: { cls: 'nonsticky', icon: 'fa-circle-check', text: 'Nonsticky',
      titel: 'Erst laeuft dein eigenes Geld. Der Bonus startet erst, wenn es aufgebraucht ist — bis dahin kannst du jederzeit auszahlen.' },
    sticky: { cls: 'sticky', icon: 'fa-lock', text: 'Sticky',
      titel: 'Einzahlung und Bonus liegen als ein Guthaben zusammen. Auszahlen geht erst, wenn der Umsatz erfuellt ist.' },
    rmw: { cls: 'rmw', icon: 'fa-coins', text: 'Real Money Wager',
      titel: 'Sticky-Variante: der Umsatz wird auf dein Echtgeld gerechnet, also auf die Einzahlung statt auf den Bonus — derselbe Faktor auf eine viel kleinere Summe.' }
  };
  function bonusArt(c) {
    if (c.bonusType && BONUSARTEN[c.bonusType]) return c.bonusType;
    if (c.sticky === true) return 'sticky';
    if (c.sticky === false || c.sticky === undefined) return 'nonsticky';
    return null;
  }
  function stickyTag(c) {
    var art = bonusArt(c);
    if (!art) return '';
    var m = BONUSARTEN[art];
    return '<span class="nk-tag nk-tag--' + m.cls + '" title="' + esc(m.titel) + '">' +
      '<i class="fa-solid ' + m.icon + '"></i> ' + m.text + '</span>';
  }

  function cardHTML(c) {
    var rankBadge = c.featured
      ? '<div class="nk-card__rank"><i class="fa-solid fa-crown"></i> Top Empfehlung</div>'
      : '<div class="nk-card__rank">' + c.rank + '</div>';

    /* Der Code-Knopf hat frueher bei JEDEM Casino "100 FS Code" behauptet.
       Die 100 Freispiele ohne Einzahlung gibt es aber nicht ueberall — bei
       MetaSpins zum Beispiel gibt der Code gar keine Freispiele. Ob sie
       dazugehoeren, steht in der Zentrale am Casino (Haken "100 Freispiele
       ohne Einzahlung"). Ohne Haken: nur der Code, ohne Geschenk-Symbol. */
    var mitFs = !!c.autoNoDep;
    var codeBtn = c.code
      ? '<button class="nk-card__code" type="button" data-code="' + esc(c.code) + '" aria-label="Promocode ' + esc(c.code) + ' kopieren' + (mitFs ? ' – 100 Freispiele ohne Einzahlung' : '') + '">' +
        '<i class="fa-solid ' + (mitFs ? 'fa-gift' : 'fa-tag') + ' nk-card__code-icon"></i>' +
        '<span class="nk-card__code-label">' + (mitFs ? '100 FS Code:' : 'Code:') + '</span>' +
        '<span class="nk-card__code-value">' + esc(c.code) + '</span></button>'
      : '';

    var nDep = c.pkg && c.pkg.steps ? c.pkg.steps.length : 0;
    var pctExplain = nDep
      ? 'Gesamtes Bonuspaket: ' + c.bonusPct + '% verteilt auf ' + nDep + ' Einzahlungen.'
      : 'Du bekommst ' + c.bonusPct + '% deiner Einzahlung als Bonus obendrauf.';
    var maxEinheit = einheitSuffix(c.maxUnit);
    var maxExplain = nDep
      ? 'Maximaler Bonus über das komplette Paket – bis zu ' + nfmt(c.maxBonus) + maxEinheit + '.'
      : 'Maximal möglicher Bonus – bis zu ' + nfmt(c.maxBonus) + maxEinheit + '.';

    /* Umsatzfaktor aus dem Bonuspaket der Zentrale (SpinBetter: 35×). Ohne
       Paket bleibt es bei den 40×, die bisher fuer alle Karten galten. */
    var wager = (c.pkg && +c.pkg.wagerBonus) || 40;

    var stats =
      statFace(true, c.bonusPct, '%', nDep ? 'Bonuspaket' : 'Bonus', pctExplain, false) +
      statFace(true, c.maxBonus, maxEinheit, 'Max Bonus', maxExplain, true) +
      statFace(true, wager, 'x', 'Wager', 'Bonus ' + wager + '× umsetzen, dann ist die Auszahlung frei.', false) +
      statFace(true, 5, '€', 'Max Bet', 'Max. 5€ Einsatz pro Runde, solange der Bonus läuft.', false);

    var payoutFast = c.payoutRank === 1;

    return '' +
      '<article class="nk-card nk-reveal' + (c.featured ? ' nk-card--featured' : '') + '" ' +
        'data-id="' + c.id + '" data-casino="' + esc(c.name) + '" data-rank="' + c.rank + '"' + (c.featured ? ' data-featured="1"' : '') + ' data-bonuspct="' + c.bonusPct + '" ' +
        'data-maxbonus="' + c.maxBonus + '" data-freespins="' + c.freespins + '" data-payout="' + c.payoutRank + '">' +
      '<div class="nk-card__sheen"></div><div class="nk-card__spot"></div>' +
      rankBadge +
      /* Band in der Ecke: nur Giveaway-Casinos duerfen "Giveaway Casino" tragen.
         SpinBetter steht auf der Front, nimmt aber nicht teil (Zentrale: Gewinnspiel = Nein). */
      (c.giveaway === false
        ? '<div class="nk-card__ribbon"><span>Partner</span><span>Casino</span></div>'
        : '<div class="nk-card__ribbon"><span>Giveaway</span><span>Casino</span></div>') +
      '<div class="nk-card__inner">' +
        '<div class="nk-card__logo-wrap"><img class="nk-card__logo ' + (c.logoMod || '') + '" src="' + c.logo + '" alt="' + esc(c.name) + ' Logo" loading="lazy"></div>' +
        '<div class="nk-card__eyebrow">' + (nDep ? 'Exklusives Bonuspaket · ' + nDep + ' Einzahlungen' : (c.giveaway === false ? 'Exklusives Angebot' : 'Exklusives Giveaway-Angebot')) + '</div>' +
        '<div class="nk-card__bonus">' + esc(c.bonus) + '</div>' +
        '<div class="nk-card__payout"><i class="fa-solid fa-bolt"></i> Auszahlung: <span class="' + (payoutFast ? 'b' : '') + '">' + esc(c.payoutText) + '</span></div>' +
        '<div class="nk-tags">' + stickyTag(c) + codeBtn + '</div>' +
        '<div class="nk-card__stats">' + stats + '</div>' +
        pkgHTML(c) +
        '<div class="nk-card__highlight">' + c.highlight + '</div>' +
        payPanel(c) +
        '<div class="nk-card__action"><a class="nk-card__cta" href="' + c.cta + '" target="_blank" rel="noopener sponsored">🔥 Jetzt spielen 🔥</a></div>' +
      '</div></article>';
  }

  /* ======================================================================
     EXKLUSIVE CASINOS — ohne Giveaway
     ----------------------------------------------------------------------
     Eigener Block ganz unten. Diese Casinos nehmen NICHT am Gewinnspiel teil,
     deshalb bekommen sie eine eigene Karte: grün statt gold, ohne
     Ticket-Bezug, ohne Giveaway-Banderole.

     Bewusst OHNE die Kacheln „Wager 40×" und „Max Bet 5€": die stehen bei den
     Giveaway-Karten fest verdrahtet im Code. Für ein neues Casino wären sie
     schlicht geraten — und falsche Bonusbedingungen sind das Letzte, was auf
     so eine Seite gehört.

     Gepflegt in der Zentrale: Casino-Hub → Kanal „Hauptfront · Exklusiv".
     Die Liste hier unten ist nur der Rückfall, falls der Hub nicht antwortet.
     ====================================================================== */
  var EXKLUSIV = [
    {
      id: 'goldenplay',
      rank: 1,
      name: 'GoldenPlay',
      logo: 'https://cdn.shopify.com/s/files/1/0965/9813/1028/files/GoldenPlay-logo-340x160-1.png?v=1787823987',
      logoMod: '',
      // Die Kopfzeile ist das Geschenk, nicht das Bonuspaket — das ist der
      // Grund, warum jemand hier klickt.
      gratis: '7 € kostenlos auf deine erste Einzahlung',
      bonus: '100 % Bonus + 100 Freispiele',
      bonusPct: 100,
      freespins: 100,
      payoutText: '',
      cta: 'https://record.gplaynetopartners.com/_0f4eimxMKnlQmk4VfOXiD2Nd7ZgqdRLk/1/?pg=1&payload=&cid='
    }
  ];

  /* Eigener Bausatz statt nk-card__*: die Gold-Karten sind auf Bonuspakete,
     Wager-Kacheln und Giveaway-Banderole ausgelegt. Ein exklusives Casino hat
     davon nichts. Auf ihren Klassen aufzusetzen hiess, gegen ihr Aussehen
     anzukaempfen — und jede kuenftige Aenderung an den Gold-Karten haette den
     Block hier mitgerissen. Deshalb ein sauber getrennter Namensraum nk-ex-*. */
  /* Die Hinweiszeile darf in der Zentrale <strong> enthalten. Auf dieser Karte
     wird sie als reiner Text gesetzt — Markup aus der Datenbank blind ins DOM
     zu schreiben ist genau der Weg, auf dem man sich Fremdcode einfaengt. */
  function stripTags(v) {
    return String(v == null ? '' : v).replace(/<[^>]*>/g, '').trim();
  }

  /* Aus der Hinweiszeile wird nur dann ein Geschenk, wenn sie auch eines ist.
     Ein Hinweis wie „nimmt nicht am Giveaway teil" gehoert nicht in die
     Werbezeile — er steht ohnehin fest auf der Karte. */
  function gratisAus(v) {
    var t = stripTags(v);
    if (!t) return '';
    if (/nimmt nicht|kein giveaway|exklusives casino$/i.test(t)) return '';
    return t;
  }

  function exklusivCardHTML(c) {
    var fs = c.freespins
      ? '<span class="nk-ex__tag">' + nfmt(c.freespins) + ' Freispiele</span>' : '';
    var pct = c.bonusPct
      ? '<span class="nk-ex__tag">' + nfmt(c.bonusPct) + ' % Bonus</span>' : '';
    var payout = c.payoutText
      ? '<span class="nk-ex__tag nk-ex__tag--quiet">' + esc(c.payoutText) + '</span>' : '';
    /* Bonusart aus der Zentrale. Nur behaupten, was dort auch gesetzt ist —
       bei einem ungeprueften Casino bleibt die Kachel weg. Auf der gruenen
       Exklusiv-Karte ohne Symbol, die Kacheln daneben tragen auch keins. */
    var artKey = (c.bonusType && BONUSARTEN[c.bonusType]) ? c.bonusType
      : c.sticky === true ? 'sticky' : c.sticky === false ? 'nonsticky' : null;
    var art = artKey
      ? '<span class="nk-ex__tag nk-ex__tag--' + BONUSARTEN[artKey].cls + '" title="' +
        esc(BONUSARTEN[artKey].titel) + '">' + BONUSARTEN[artKey].text + '</span>'
      : '';

    // Das Geschenk steht ueber allem. Wenn es fehlt, ruecken die Bonusdaten hoch —
    // dann sieht die Karte aus wie vorher, statt eine Luecke zu lassen.
    var gratis = c.gratis
      ? '<div class="nk-ex__gift">' +
          '<span class="nk-ex__gift-icon"><i class="fa-solid fa-gift"></i></span>' +
          '<span class="nk-ex__gift-text">' + esc(c.gratis) + '</span>' +
        '</div>'
      : '';

    return '' +
      '<article class="nk-ex nk-reveal' + (c.gratis ? ' nk-ex--gift' : '') + '" data-id="' + esc(c.id) + '">' +
        '<span class="nk-ex__flag">Exklusiv</span>' +
        '<div class="nk-ex__logo"><img src="' + esc(c.logo) + '" alt="' + esc(c.name) + '" loading="lazy"></div>' +
        '<div class="nk-ex__body">' +
          '<div class="nk-ex__name">' + esc(c.name) + '</div>' +
          gratis +
          '<div class="nk-ex__bonus' + (c.gratis ? ' nk-ex__bonus--sub' : '') + '">' + esc(c.bonus) + '</div>' +
          '<div class="nk-ex__tags">' + pct + fs + art + payout + '</div>' +
          '<div class="nk-ex__note">Nimmt <strong>nicht</strong> am 300.000 € Giveaway teil — Einzahlungen z\u00e4hlen hier nicht f\u00fcr Tickets.</div>' +
        '</div>' +
        '<div class="nk-ex__action">' +
          '<a class="nk-ex__cta" href="' + esc(c.cta) + '" target="_blank" rel="noopener sponsored">Bonus sichern</a>' +
          '<span class="nk-ex__fine">18+ · Es gelten die Bedingungen des Casinos</span>' +
        '</div>' +
      '</article>';
  }

  function renderExklusiv() {
    var box  = document.getElementById('nk-exklusiv');
    var head = document.getElementById('nk-exklusiv-head');
    if (!box) return;
    var leer = !EXKLUSIV.length;
    box.hidden = leer;
    if (head) head.hidden = leer;
    if (leer) { box.innerHTML = ''; return; }
    box.innerHTML = EXKLUSIV.map(exklusivCardHTML).join('');
  }

  /* Die Zentrale ist die Quelle. Antwortet sie nicht, bleibt die Liste oben. */
  function loadExklusivFromHub() {
    if (window.NK_HUB_OFF) return;
    var done = false;
    var timer = setTimeout(function () { done = true; }, 4000);

    fetch(HUB_URL.replace('/casinos/front', '/casinos/front-exklusiv'),
          { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (done || !data || !data.ok) return;
        clearTimeout(timer);

        // In der Zentrale abgeschaltet -> Block verschwindet ganz.
        if (data.online === false) { EXKLUSIV = []; renderExklusiv(); return; }

        var list = (data.casinos || []).filter(function (c) { return c && c.name && c.cta; });
        // Keine Freigaben in der Zentrale = Block aus. Das ist Absicht:
        // sonst bliebe ein abgeschaltetes Casino durch die Rückfallliste stehen.
        EXKLUSIV = list.map(function (c) {
          return {
            id: c.id, rank: c.rank, name: c.name, logo: c.logo, logoMod: c.logoMod || '',
            bonus: c.bonus, bonusPct: +c.bonusPct || 0, freespins: +c.freespins || 0,
            // Das Geschenk kommt aus dem Feld „Hinweiszeile" der Zentrale.
            // Steht dort noch der alte Hinweis-Satz statt eines Angebots, wird
            // er verworfen — sonst prangt „nimmt nicht am Giveaway teil" als
            // Werbeaussage auf der Karte.
            gratis: gratisAus(c.highlight),
            sticky: c.sticky, bonusType: c.bonusType || null,
            payoutText: c.payoutText || '', cta: c.cta
          };
        }).sort(function (a, b) { return a.rank - b.rank; });

        renderExklusiv();
        initScrollReveal(); initSpotlight();
      })
      .catch(function () { /* Hub nicht erreichbar -> Rückfallliste bleibt */ });
  }

  function renderCards() {
    var list = document.getElementById('giveaway-list');
    if (!list) return;
    list.innerHTML = CASINOS.map(cardHTML).join('');
  }

  /* --- SORTIERKOPF --- */
  var SORTS = {
    featured:  function (a, b) { return a.rank - b.rank; },
    bonus:     function (a, b) { return b.bonuspct - a.bonuspct || a.rank - b.rank; },
    maxbonus:  function (a, b) { return b.maxbonus - a.maxbonus || a.rank - b.rank; },
    payout:    function (a, b) { return a.payout - b.payout || a.rank - b.rank; },
    freespins: function (a, b) { return b.freespins - a.freespins || a.rank - b.rank; }
  };
  function initSort() {
    var bar = document.getElementById('nk-sort');
    var list = document.getElementById('giveaway-list');
    if (!bar || !list) return;
    var pills = [].slice.call(bar.querySelectorAll('.nk-sort-pill'));
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var key = pill.getAttribute('data-sort');
        pills.forEach(function (p) { p.setAttribute('aria-pressed', p === pill ? 'true' : 'false'); });
        var cards = [].slice.call(list.querySelectorAll('.nk-card'));
        var data = cards.map(function (el) {
          return { el: el, rank: +el.dataset.rank, bonuspct: +el.dataset.bonuspct,
                   maxbonus: +el.dataset.maxbonus, freespins: +el.dataset.freespins, payout: +el.dataset.payout };
        });
        data.sort(SORTS[key] || SORTS.featured);
        // Featured-Karte nur im Default-Sort über volle Breite, sonst normale Zelle
        data.forEach(function (d, i) {
          d.el.style.order = i;
          if (key !== 'featured') d.el.classList.remove('nk-card--featured');
          else if (d.el.dataset.featured === '1') d.el.classList.add('nk-card--featured');
        });
      });
    });
  }

  /* --- BACKGROUND PARTICLES --- */
  function initParticles() {
    var canvas = document.querySelector('.nk-bgfx__canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var w, h, particles = [], mouse = { x: -1000, y: -1000 };
    function resize() { w = canvas.width = window.innerWidth; h = canvas.height = window.innerHeight; }
    resize(); window.addEventListener('resize', resize);
    window.addEventListener('mousemove', function (e) { mouse.x = e.clientX; mouse.y = e.clientY; });
    var COUNT = Math.min(80, Math.floor(window.innerWidth / 16));
    var COLORS = ['rgba(255,216,74,0.7)','rgba(255,182,46,0.6)','rgba(255,240,183,0.5)','rgba(168,85,247,0.4)','rgba(52,240,180,0.35)'];
    for (var i = 0; i < COUNT; i++) {
      particles.push({ x: Math.random()*w, y: Math.random()*h, r: Math.random()*2.2+0.5,
        vx:(Math.random()-0.5)*0.32, vy:(Math.random()-0.5)*0.32,
        color: COLORS[Math.floor(Math.random()*COLORS.length)], pulse: Math.random()*Math.PI*2 });
    }
    function draw() {
      ctx.clearRect(0,0,w,h);
      for (var i=0;i<particles.length;i++) {
        var p = particles[i]; p.pulse += 0.015; var scale = 1 + Math.sin(p.pulse)*0.3;
        p.x += p.vx; p.y += p.vy;
        if (p.x<0) p.x=w; if (p.x>w) p.x=0; if (p.y<0) p.y=h; if (p.y>h) p.y=0;
        var dx=mouse.x-p.x, dy=mouse.y-p.y, dist=Math.sqrt(dx*dx+dy*dy);
        if (dist<160) { p.x-=dx*0.006; p.y-=dy*0.006; }
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r*scale,0,Math.PI*2); ctx.fillStyle=p.color; ctx.fill();
        for (var j=i+1;j<particles.length;j++) {
          var p2=particles[j], ddx=p.x-p2.x, ddy=p.y-p2.y, d=Math.sqrt(ddx*ddx+ddy*ddy);
          if (d<130) { ctx.beginPath(); ctx.moveTo(p.x,p.y); ctx.lineTo(p2.x,p2.y);
            ctx.strokeStyle='rgba(255,215,90,'+(0.08*(1-d/130))+')'; ctx.lineWidth=0.5; ctx.stroke(); }
        }
      }
      requestAnimationFrame(draw);
    }
    draw();
  }

  /* --- SCROLL REVEAL --- */
  function initScrollReveal() {
    var els = document.querySelectorAll('.nk-reveal:not(.nk-visible)');
    if (!els.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('nk-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el, i) { el.style.transitionDelay = (i % 6) * 55 + 'ms'; observer.observe(el); });
  }

  /* --- CURSOR SPOTLIGHT --- */
  function initSpotlight() {
    document.querySelectorAll('.nk-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        card.style.setProperty('--mx', ((e.clientX - rect.left) / rect.width * 100) + '%');
        card.style.setProperty('--my', ((e.clientY - rect.top) / rect.height * 100) + '%');
      });
    });
  }

  /* --- COUNTER ANIMATION --- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count')) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var group = el.hasAttribute('data-group');
        var duration = 1400, startTime = null;
        // So viele Nachkommastellen wie das Ziel: 1.500 zaehlt ganzzahlig
        // hoch, 0,05 BTC bleibt 0,05 statt auf 0 gerundet zu werden.
        var dec = (String(target).split('.')[1] || '').length;
        function fmt(n) {
          if (dec) return n.toLocaleString('de-DE', { minimumFractionDigits: dec, maximumFractionDigits: dec });
          return group ? Math.round(n).toLocaleString('de-DE') : Math.round(n);
        }
        function animate(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = fmt(eased * target) + suffix;
          if (progress < 1) requestAnimationFrame(animate);
          else el.textContent = fmt(target) + suffix;
        }
        requestAnimationFrame(animate);
        observer.unobserve(el);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { observer.observe(c); });
  }

  /* --- PROMOCODE COPY --- */
  function initCodeCopy() {
    document.querySelectorAll('[data-code]').forEach(function (el) {
      if (el.dataset.nkBound) return; el.dataset.nkBound = '1';
      el.addEventListener('click', function () {
        var text = (el.getAttribute('data-code') || '').trim();
        if (!text) return;
        if (navigator.clipboard) { navigator.clipboard.writeText(text).catch(function(){}); }
        else {
          var ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta);
        }
        el.classList.add('nk-copied');
        var icon = el.querySelector('.nk-card__code-icon');
        var prev = icon ? icon.className : null;
        if (icon) icon.className = 'nk-card__code-icon fa-solid fa-check';
        setTimeout(function () { el.classList.remove('nk-copied'); if (icon && prev) icon.className = prev; }, 1500);
      });
    });
  }

  /* --- STAT FLIP-KARTEN --- */
  function initFlip() {
    document.querySelectorAll('.nk-card__stat').forEach(function (s) {
      if (s.dataset.nkBound) return; s.dataset.nkBound = '1';
      s.addEventListener('click', function () { s.classList.toggle('nk-flip'); });
      s.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); s.classList.toggle('nk-flip'); }
      });
    });
  }

  /* --- BONUSPAKET AUF-/ZUKLAPPEN --- */
  function initPkg() {
    document.querySelectorAll('.nk-pkg__toggle').forEach(function (btn) {
      if (btn.dataset.nkBound) return; btn.dataset.nkBound = '1';
      btn.addEventListener('click', function () {
        var pkg = btn.closest('.nk-pkg');
        var open = pkg.classList.toggle('nk-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var more = btn.querySelector('.nk-pkg__more');
        if (more) more.firstChild.nodeValue = open ? 'Einklappen ' : 'Einzahlungen ansehen ';
      });
    });
  }

  /* --- DETAILS & ZAHLUNGEN ACCORDION --- */
  function initDetails() {
    document.querySelectorAll('.nk-card__pay-toggle').forEach(function (btn) {
      if (btn.dataset.nkBound) return; btn.dataset.nkBound = '1';
      btn.addEventListener('click', function () {
        var card = btn.closest('.nk-card');
        var open = card.classList.toggle('nk-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* --- SMOOTH-SCROLL für Hero-CTAs --- */
  function initAnchors() {
    document.querySelectorAll('[data-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('data-scroll'));
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  /* ==========================================================
     SUPABASE-INTEGRATIONEN (unverändert übernommen)
     ========================================================== */
  var SB_URL = 'https://cbwxgikndyyzdslmfpmo.supabase.co';
  var SB_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNid3hnaWtuZHl5emRzbG1mcG1vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4MzYzNTcsImV4cCI6MjA5MzQxMjM1N30.zvKKQ7sN6hhMRmwaJVYmjI0cgZDktyXnTb7iYWL4ZPI';
  var LIVE_TIME = '18:00';
  var TWITCH_HOME = 'https://www.twitch.tv/nouri_amk';

  /* --- TWITCH-BANNER ---------------------------------------------------
     Seit 08.09.2026 kein „wer streamt heute" mehr: keine Namen, keine
     Chips, kein Dienstplan-Abruf. Der Banner steht fest im Markup; hier wird
     nur der Live-Zustand angesteuert — läuft gerade ein AMK-Stream (Snapshot
     jünger als 20 Minuten), zeigt der Banner „LIVE JETZT" samt Zuschauern
     und der Knopf führt direkt in den laufenden Stream. Ohne Antwort aus
     Supabase bleibt der Banner wie er ist: täglich live, ab 18 Uhr. */
  function initLiveStream() {
    var card = document.getElementById('nk-twitch-link');
    if (!card) return;
    var headers = { apikey: SB_KEY, Authorization: 'Bearer ' + SB_KEY };
    var twUrl = SB_URL + '/rest/v1/twitch_snapshots?select=channel_login,live,viewer_count,created_at&order=created_at.desc&limit=16';
    fetch(twUrl, { headers: headers })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (snaps) { paintTwitch(card, Array.isArray(snaps) ? snaps : []); })
      .catch(function () { /* Banner bleibt im Ruhezustand */ });
  }

  function paintTwitch(card, snaps) {
    var seen = {}, now = Date.now(), liveOne = null;
    snaps.forEach(function (s) {
      if (!s || seen[s.channel_login]) return;
      seen[s.channel_login] = 1;
      if (s.live && !liveOne && (now - new Date(s.created_at).getTime()) < 20 * 60 * 1000) liveOne = s;
    });
    var status = document.getElementById('nk-twitch-status');
    var cta = document.getElementById('nk-twitch-cta');
    var section = card.closest('.nk-twitch');
    if (!liveOne) {
      if (section) section.classList.remove('nk-twitch--live');
      card.href = TWITCH_HOME;
      if (status) status.innerHTML = '<span class="nk-twitch__dot"></span>Täglich live · ab ' + LIVE_TIME + ' Uhr';
      if (cta) cta.innerHTML = '<i class="fa-brands fa-twitch"></i> <span>Zum Twitch-Kanal</span> <i class="fa-solid fa-arrow-right"></i>';
      return;
    }
    if (section) section.classList.add('nk-twitch--live');
    card.href = liveOne.channel_login ? 'https://www.twitch.tv/' + encodeURIComponent(liveOne.channel_login) : TWITCH_HOME;
    var viewers = Number(liveOne.viewer_count) || 0;
    if (status) status.innerHTML = '<span class="nk-twitch__dot"></span>LIVE JETZT' +
      (viewers ? ' · <b>' + viewers.toLocaleString('de-DE') + '</b> Zuschauer' : '');
    if (cta) cta.innerHTML = '<i class="fa-brands fa-twitch"></i> <span>Jetzt live ansehen</span> <i class="fa-solid fa-arrow-right"></i>';
  }

  /* --- 20X TICKET BOOST --- */
  var BOOST_WD = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
  function bPad(n){ return (n<10?'0':'')+n; }
  function bDur(s){ s=Math.max(0,Math.floor(s)); var h=Math.floor(s/3600),m=Math.floor(s%3600/60),ss=s%60; return h>0?(h+'h '+bPad(m)+'m '+bPad(ss)+'s'):(bPad(m)+'m '+bPad(ss)+'s'); }
  function bWeekday(ddmmyyyy){ var p=String(ddmmyyyy||'').split('.'); if(p.length<3) return ''; var d=new Date(+p[2],+p[1]-1,+p[0]); return isNaN(d)?'':BOOST_WD[d.getDay()]; }
  /* Boost-Abzeichen auf den Casino-Karten — zeigt, wo der Boost wirklich greift */
  function paintCardBoost() {
    var b = window.NK_BOOST; if (!b) return;
    Array.prototype.forEach.call(document.querySelectorAll('.nk-card'), function (card) {
      var name = card.getAttribute('data-casino') || '';
      var hit = (b.casinos || []).filter(function (c) {
        return String(c.casino).toLowerCase() === name.trim().toLowerCase();
      })[0];
      var on = !!(hit && hit.enabled && hit.multiplier > 1);
      var badge = card.querySelector('.nk-card__boost');
      card.classList.toggle('nk-card--boost', on && b.windowOpen);
      if (!on) { if (badge) badge.remove(); return; }
      if (!badge) {
        badge = document.createElement('div'); badge.className = 'nk-card__boost';
        var inner = card.querySelector('.nk-card__inner');
        if (inner) inner.insertBefore(badge, inner.firstChild); else card.appendChild(badge);
      }
      badge.innerHTML = '<i class="fa-solid fa-bolt"></i> ' + hit.multiplier + 'X Ticket-Boost' +
        (b.windowOpen ? ' <span class="nk-card__boost-live">läuft gerade</span>' : '');
    });
  }

  function initBoost() {
    var band = document.getElementById('boost');
    if (!band) return;
    var live = document.getElementById('nk-boost-live'), cd = document.getElementById('nk-boost-cd'),
        next = document.getElementById('nk-boost-next'), ticker = document.getElementById('nk-boost-ticker'),
        list = document.getElementById('nk-boost-list'), total = document.getElementById('nk-boost-total');
    var secLeft = 0, timer = null;
    function paint(){ if (cd) cd.textContent = bDur(secLeft); if (secLeft<=0 && timer){ clearInterval(timer); } }
    function startCd(s){ secLeft = s; paint(); if (timer) clearInterval(timer); timer = setInterval(function(){ secLeft--; if (secLeft<0) secLeft=0; paint(); }, 1000); }
    function render(d){
      // Zentrale entscheidet, ob das Band steht. banner_visible kennt auch den
      // Modus „nur wenn der Boost laeuft"; aeltere Antworten nur show_banner.
      var sichtbar = (typeof d.banner_visible === 'boolean') ? d.banner_visible : (d.show_banner !== false);
      // Ticket-Eingabe in der Zentrale gesperrt: dann wirbt kein Boost-Band mehr
      // fuer Einzahlungen, die gar keine Tickets mehr bringen.
      if (d.entries_open === false) sichtbar = false;
      if (!sichtbar) { band.hidden = true; band.style.display = 'none'; return; }
      band.hidden = false; band.style.display = '';
      // Banner-Bild aus der Zentrale (leer = das im Theme hinterlegte behalten)
      var img = band.querySelector('.nk-boost__img');
      if (img && d.banner_url && img.getAttribute('src') !== d.banner_url) img.setAttribute('src', d.banner_url);
      // Freigabe je Casino aus der Zentrale — der Boost gilt nur dort, wo er scharf ist.
      var cas = d.casinos || [];
      var scharf = cas.filter(function (c) { return c.enabled && c.multiplier > 1; });
      var alle = scharf.length > 0 && scharf.length === cas.length;
      var x = d.multiplier || 20;
      var wo = !scharf.length ? ' <b>Aktuell ist kein Casino freigeschaltet.</b>'
             : alle ? ''
             : ' Gilt <b>nur bei ' + scharf.map(function (c) { return esc(c.casino); }).join(' · ') + '</b>.';
      window.NK_BOOST = { active: !!d.active, windowOpen: !!d.window_open, multiplier: x, casinos: cas,
                          armed: scharf.map(function (c) { return c.casino; }), alle: alle };
      paintCardBoost();
      if (d.active) {
        if (live) live.hidden = false;
        if (next) next.innerHTML = '🔥 <b>' + x + 'X TICKET BOOST läuft gerade</b> — jede Einzahlung zählt ' + x + '-fach!' + wo;
        startCd(d.seconds_left || 0);
      } else {
        if (live) live.hidden = true;
        if (next) next.innerHTML = 'Nächster Boost: <b>' + BOOST_WD[d.weekday||0] + ' ' + bPad(d.start_hour||16) + ':00 Uhr</b> — jede Einzahlung zählt <b>' + x + '-fach</b>.' + wo;
      }
      var days = (d.days || []).filter(function(x){ return x.extra > 0; });
      if (days.length && ticker) {
        ticker.hidden = false;
        if (total) total.textContent = nfmt(d.totalExtra || days.reduce(function(a,x){return a+x.extra;},0)) + ' Extra-Punkte vergeben';
        if (list) list.innerHTML = days.map(function(x){ var wd = bWeekday(x.day);
          return '<div class="nk-boost__row"><div class="nk-boost__row-day">' + (wd?esc(wd)+' ':'') + esc(x.day) +
                 '<small>' + nfmt(x.deposits) + ' Einzahlungen · x' + (x.mult||20) + ' Boost</small></div>' +
                 '<div class="nk-boost__row-extra">+' + nfmt(x.extra) + '<small>Extra-Punkte</small></div></div>'; }).join('');
      }
    }
    fetch(SB_URL + '/functions/v1/giveaway', { method: 'POST', headers: { apikey: SB_KEY, Authorization: 'Bearer ' + SB_KEY, 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'boost_status' }) })
      .then(function(r){ return r.json().catch(function(){ return {}; }); })
      .then(function(d){ if (d && d.status === 'success') render(d); })
      .catch(function(){});
  }

  /* --- CASINOS AUS DEM HUB NACHLADEN ---
     Laeuft NACH dem ersten Rendern. Kommt eine gueltige Liste zurueck,
     werden die Karten ersetzt und die kartenabhaengigen Teile neu verdrahtet.
  --------------------------------------------------------------------- */
  function loadFromHub() {
    if (window.NK_HUB_OFF) return;
    var done = false;
    var timer = setTimeout(function () { done = true; }, 4000); // nie haengen bleiben

    fetch(HUB_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (done || !data || !data.ok) return;
        clearTimeout(timer);

        // In der Zentrale offline geschaltet: keine Karten, stattdessen der
        // Hinweis von dort. Die Seite selbst bleibt erreichbar — nur der
        // Casino-Bereich macht zu. Gedacht fuer "Aktion vorbei" oder
        // "wird gerade ueberarbeitet", ohne jedes Casino einzeln abzuhaken.
        if (data.online === false) {
          var box = document.getElementById('giveaway-list');
          if (box) {
            box.innerHTML = '<div class="nk-offline">' +
              String(data.offline_note || 'Die Casino-Auswahl ist gerade nicht verfügbar.')
                .replace(/[&<>"']/g, function (c) {
                  return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c];
                }) +
              '</div>';
          }
          CASINOS = [];
          return;
        }

        if (!data.casinos || !data.casinos.length) return;

        // Nur uebernehmen, was auch wirklich anzeigbar ist
        var list = data.casinos.filter(function (c) { return c && c.name && c.cta; });
        if (!list.length) return;

        CASINOS = list.map(function (c) {
          return {
            id: c.id, rank: c.rank, featured: !!c.featured, brand: c.brand || 'roy',
            name: c.name, logo: c.logo, logoMod: c.logoMod || '',
            bonus: c.bonus, bonusPct: +c.bonusPct || 0, maxBonus: +c.maxBonus || 0,
            maxUnit: c.maxUnit || '€',
            freespins: +c.freespins || 0,
            payoutText: c.payoutText || '', payoutRank: +c.payoutRank || 3,
            code: c.code || '', autoNoDep: !!c.autoNoDep,
            giveaway: c.giveaway !== false,   // Zentrale: nimmt am Gewinnspiel teil?
            sticky: c.sticky, bonusType: c.bonusType || null,
            highlight: c.highlight || '', pkg: c.pkg || null, cta: c.cta,
            providers: c.providers || null, pay: c.pay || null
          };
        }).sort(function (a, b) { return a.rank - b.rank; });

        renderCards();
        // Alles, was an den Karten haengt, neu verdrahten
        initSort(); initScrollReveal(); initSpotlight();
        initCodeCopy(); initFlip(); initPkg(); initDetails();
        paintCardBoost();   // Boost-Abzeichen wieder anbringen
      })
      .catch(function () { /* Hub nicht erreichbar -> eingebaute Liste bleibt */ });
  }

  /* --- INIT --- */
  function init() {
    renderCards();       // Karten zuerst rendern (eingebaute Liste)
    renderExklusiv();    // exklusive Casinos ganz unten
    loadFromHub();       // dann die Zentrale fragen
    loadExklusivFromHub();
    initSort();
    initParticles();
    initBoost();
    initScrollReveal();
    initSpotlight();
    initCounters();
    initCodeCopy();
    initFlip();
    initPkg();
    initDetails();
    initAnchors();
    initLiveStream();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
